import styled from "styled-components";

export const FixedSearch = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #c6cdd4;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const ModalProductTitle = styled.span`
  display: inline-block;
  max-width: 85%;
  white-space: normal;
  overflow-wrap: break-word;
`;

export const ModalVariantTitle = styled.span`
  display: inline-block;
  max-width: 67%;
  white-space: normal;
  overflow-wrap: break-word;

  > span {
    margin-left: 20px;
  }
`;

export const ThumbnailContainer = styled.div`
  margin-left: 3rem;
`;
